import { render, staticRenderFns } from "./page-userdetail.vue?vue&type=template&id=12f67480&scoped=true&lang=html&"
import script from "./page-userdetail.vue?vue&type=script&lang=js&"
export * from "./page-userdetail.vue?vue&type=script&lang=js&"
import style0 from "./page-userdetail.vue?vue&type=style&index=0&id=12f67480&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f67480",
  null
  
)

export default component.exports